(() => {
  if (window.SalibayHomePicks) { window.SalibayHomePicks(); return; }
  const initialized = new WeakSet();
  const refreshMs = 30 * 60 * 1000;
  const cacheMs = 6 * 60 * 60 * 1000;
  const safeImage = value => typeof value === 'string' && (/^\/apps\/salibay-search\/image\//.test(value) || /^https:\/\//.test(value));
  const fingerprint = products => products.map(product => product.publicId).join('|');
  const read = key => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const write = (key,value) => { try {localStorage.setItem(key,JSON.stringify(value));} catch (_) {} };

  function initialize(card) {
    if (initialized.has(card)) return;
    initialized.add(card);
    const market = card.dataset.homeMarket;
    if (!['usa','uk'].includes(market)) return;
    const grid = card.querySelector('.campaign-product-grid');
    if (!grid) return;
    const key = `salibay:home-picks:v1:${market}`;
    const cursorKey = `${key}:cursor`;
    let pool = [];
    let busy = false;
    let renderedAt = 0;
    let controller;
    let disposed = false;

    async function render(products) {
      if (products.length < 4 || disposed || card.contains(document.activeElement)) return false;
      const cursor = read(cursorKey);
      const offset = Number.isInteger(cursor) ? cursor % products.length : (Math.floor(Date.now()/refreshMs)*4) % products.length;
      const candidates = [];
      for (let i=0;i<Math.min(products.length,12);i++) candidates.push(products[(offset+i)%products.length]);
      const tiles = [];
      for (let start=0;start<candidates.length && tiles.length<4;start+=4) {
        const loaded = await Promise.all(candidates.slice(start,start+4).map(product => new Promise(resolve => {
          const image = new Image(400,400);
          const timer = setTimeout(() => {image.onload=null;image.onerror=null;resolve(null);},8000);
          image.onload = () => {clearTimeout(timer);resolve({product,image});};
          image.onerror = () => {clearTimeout(timer);resolve(null);};
          image.alt = product.title; image.decoding='async'; image.src=product.imageUrl;
        })));
        tiles.push(...loaded.filter(Boolean));
      }
      if (tiles.length<4 || disposed || !card.isConnected || card.contains(document.activeElement)) return false;
      const fragment = document.createDocumentFragment();
      for (const {product,image} of tiles.slice(0,4)) {
        const link = document.createElement('a');
        link.className='campaign-product-tile';
        link.href=`/search?q=${encodeURIComponent(product.title)}`;
        const frame = document.createElement('span'); frame.className='campaign-product-image'; frame.append(image);
        const name = document.createElement('span'); name.className='campaign-product-name'; name.textContent=product.title;
        link.append(frame,name);
        link.addEventListener('click',event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button!==0 || !window.Salibay?.openDiscoveryProduct) return;
          event.preventDefault(); window.Salibay.openDiscoveryProduct(product);
        });
        fragment.append(link);
      }
      grid.replaceChildren(fragment);
      grid.dataset.liveMarket=market;
      write(cursorKey,(offset+4)%products.length);
      renderedAt=Date.now();
      return true;
    }

    async function refresh(rotate=false) {
      if (busy || disposed || document.hidden || card.contains(document.activeElement)) return;
      busy=true; card.setAttribute('aria-busy','true');
      controller=new AbortController();
      let timer;
      try {
        if (!pool.length) {
          const saved=read(key);
          if (saved && Date.now()-saved.savedAt<cacheMs && Array.isArray(saved.products)) {
            pool=saved.products.filter(product => product && product.publicId && product.title && safeImage(product.imageUrl));
            await render(pool);
          }
        }
        if (disposed) return;
        timer=setTimeout(() => controller.abort(),20000);
        const response=await fetch(`/apps/salibay-search/discover?market=${market}&page=1`,{signal:controller.signal,headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Market refresh unavailable');
        const feed=await response.json();
        const seen=new Set();
        const products=(Array.isArray(feed.products)?feed.products:[]).filter(product => {
          const correctMarket=market==='usa' ? /\busa\b|united states/i.test(product?.originLabel || '') : /\buk\b|united kingdom/i.test(product?.originLabel || '');
          if (!product?.publicId || !product.title || !safeImage(product.imageUrl) || !correctMarket || seen.has(product.publicId)) return false;
          seen.add(product.publicId); return true;
        });
        if (products.length<4) throw new Error('Not enough usable market products');
        const changed=fingerprint(products)!==fingerprint(pool);
        pool=products;
        write(key,{savedAt:Date.now(),products});
        if (!renderedAt || changed || rotate) await render(pool);
      } catch (_) {
        // Saved Shopify picks remain usable if a market or image host is unavailable.
        if (rotate && pool.length && !disposed) await render(pool);
      } finally {
        clearTimeout(timer);busy=false;card.removeAttribute('aria-busy');
      }
    }
    const onReturn=() => {if (!document.hidden && Date.now()-renderedAt>=refreshMs) refresh(true);};
    const onPageShow=event => {if (event.persisted) refresh(true);};
    document.addEventListener('visibilitychange',onReturn);
    window.addEventListener('pageshow',onPageShow);
    const interval=setInterval(() => refresh(true),refreshMs);
    const dispose=event => {
      if (!event.target.contains(card)) return;
      disposed=true;controller?.abort();clearInterval(interval);
      document.removeEventListener('visibilitychange',onReturn);
      window.removeEventListener('pageshow',onPageShow);
      document.removeEventListener('shopify:section:unload',dispose);
    };
    document.addEventListener('shopify:section:unload',dispose);
    refresh();
  }
  window.SalibayHomePicks=() => document.querySelectorAll('[data-home-market]').forEach(initialize);
  document.addEventListener('shopify:section:load',window.SalibayHomePicks);
  window.SalibayHomePicks();
})();
